import { useContext } from "react";
import { MyContext } from "../context/myContext";
import {useDispatch} from "react-redux";
import {changeRegisterBtnType} from "../features/common-states/commonStatesSlice";

const FormFooter = ({ handleReset }) => {
    const { formTitle, handleShowForm, registerBtn, content } = useContext(MyContext);
    const dispatch = useDispatch()
    return (
        <div className="form-footer">
            <div>
                <button className="reject-btn" type="button" onClick={handleShowForm}>
                    انصراف
                </button>
                {(registerBtn === 'ویرایش اطلاعات' || registerBtn === 'ثبت اطلاعات') &&
                    <button type='submit' className={`edit-req-form-btn ${registerBtn === 'ویرایش اطلاعات' ? 'confirm-deliver-btn' : 'reject-req-btn'}`} onClick={() => dispatch(changeRegisterBtnType(registerBtn === 'ویرایش اطلاعات' ? 'تایید تحویل' : 'رد درخواست'))}>{registerBtn === 'ویرایش اطلاعات' ? 'تایید تحویل' : 'رد درخواست'}</button>
                }
                {content !== 'ثبت تحویل آب توسط کاربر' && content !== 'این درخواست رد شده است' &&
                    <button className="registration-btn" type="submit" onClick={() => formTitle !== 'افزودن درخواست جدید' && formTitle !== 'تغییر رمزعبور' && dispatch(changeRegisterBtnType(registerBtn ?? 'ثبت'))}>
                        {registerBtn ?? 'ثبت'}
                    </button>
                }
                {(formTitle === "تعریف کاربر جدید" || formTitle === 'ویرایش کاربر') && (
                    <button className="clear-btn" type="button" onClick={handleReset}>
                        پاکسازی فرم
                    </button>
                )}
            </div>
            <p>موارد نشان دار الزامی هستند*</p>
        </div>
    );
};

export default FormFooter;